import { useEffect, useState } from "react"

const STAFF_SUPERVISOR_COOKIE_NAME = "autoleadsStaffSupervisor"
const STAFF_SUPERVISOR_CHANGE_EVENT = "autoleads:staff-supervisor-change"
const MAX_AGE_SECONDS = 365 * 24 * 60 * 60

export function getStaffSupervisorCookie(): boolean {
  if (typeof document === "undefined") return false
  const match = document.cookie.match(
    new RegExp(`(?:^|;\\s*)${STAFF_SUPERVISOR_COOKIE_NAME}=([^;]*)`),
  )
  return match?.[1]?.trim() === "1"
}

export function setStaffSupervisorCookie(value: 0 | 1): void {
  if (typeof document === "undefined") return
  document.cookie = `${STAFF_SUPERVISOR_COOKIE_NAME}=${value}; path=/; max-age=${MAX_AGE_SECONDS}; samesite=lax`
  window.dispatchEvent(new CustomEvent(STAFF_SUPERVISOR_CHANGE_EVENT))
}

export function useStaffSupervisor(): boolean {
  const [value, setValue] = useState<boolean>(() => getStaffSupervisorCookie())
  useEffect(() => {
    const handler = () => setValue(getStaffSupervisorCookie())
    window.addEventListener(STAFF_SUPERVISOR_CHANGE_EVENT, handler)
    return () =>
      window.removeEventListener(STAFF_SUPERVISOR_CHANGE_EVENT, handler)
  }, [])
  return value
}
